export const MARK_HOVER_CLOSE_DELAY_MS = 300;

export function findParentMark(
  element: HTMLElement | null,
  editorElement: HTMLElement,
  markDataAttribute: string
): HTMLElement | null {
  let current = element;
  while (current && current !== editorElement) {
    if (current.hasAttribute(markDataAttribute)) {
      return current;
    }
    current = current.parentElement;
  }
  return null;
}

export function isMovingToHoverCard(
  relatedTarget: HTMLElement | null,
  hoverCardContentRef: HTMLElement | null
): boolean {
  if (!relatedTarget) {
    return false;
  }
  return !!(
    hoverCardContentRef?.contains(relatedTarget) ||
    relatedTarget.closest('[data-radix-hover-card-content]') ||
    relatedTarget.closest('[data-radix-hover-card-trigger]')
  );
}

export function computeMarkHoverPosition(rect: DOMRect): { top: number; left: number } {
  const viewportWidth = window.innerWidth;
  const isMobileDevice = viewportWidth <= 768;
  const leftPosition = isMobileDevice
    ? Math.min(rect.left + window.scrollX + rect.width / 2, window.scrollX + viewportWidth - 16)
    : rect.left + window.scrollX + rect.width / 2;
  return {
    top: rect.bottom + window.scrollY,
    left: leftPosition,
  };
}
